import { ChartConfig } from '@/components/ui/chart';
import {
  UsageLogByModelAndTime,
  UsageLogsByModelAndTime,
} from '@/service/llm/usage-logs/type';
import dayjs from 'dayjs';

export interface ChartDataItem {
  date: number;
  [model: string]: number;
}

type UsageItem = UsageLogByModelAndTime;

type DataKey<T> = {
  [K in keyof T]: T[K] extends number ? K : never;
}[keyof T];

export function transformDataForChart<T extends UsageItem>(
  rawData: T[],
  dataKey: DataKey<T> = 'count' as DataKey<T>
): ChartDataItem[] {
  if (!rawData || rawData.length === 0) return [];

  const groupedData: { [key: string]: ChartDataItem } = {};

  rawData.forEach((item) => {
    const date = dayjs(item.time_bucket);
    const dateKey = date.toISOString();

    if (!groupedData[dateKey]) {
      groupedData[dateKey] = { date: date.unix() };
    }

    if (dataKey in item && typeof item[dataKey] === 'number') {
      groupedData[dateKey][item.model] = item[dataKey as keyof T] as number;
    }
  });

  return Object.values(groupedData);
}

export function generateChartConfig(data: string[]): ChartConfig {
  const uniqueModels = Array.from(new Set(data));
  // const uniqueModels = Array.from(new Set(data.map((item) => item.model)));
  return uniqueModels.reduce((config, model, index) => {
    config[index.toString()] = {
      label: model,
      color: `hsl(var(--chart-${index + 1}))`,
    };
    return config;
  }, {} as ChartConfig);
}
